<template>
  <div
    class="consent-item bg-white p-3 cursor--pointer"
    :class="{ 'consent-item--selected': isSelected }"
    @click="emit('select', consent.id)"
  >
    <div class="d-flex justify-content-between align-items-start">
      <span class="fw-bold font-14" :class="isSelected ? 'text-danger' : ''">
          {{ getLocalizedContent(consent.title) || consent.name }}
        </span>
      <span v-if="consent.required" class="badge bg-danger ms-2 flex-shrink-0" style="font-size: 10px; border-radius: 0">
          {{ $t('consents.required') }}
        </span>
      </div>

    <div class="mt-1">
      <small v-if="isAnswered" class="success-green fw-bold">{{ $t('consents.answered') }}</small>
      <small v-else-if="isRead" class="text-gray">{{ $t('consents.read') }}</small>
      <small v-else class="text-danger">{{ $t('consents.notRead') }}</small>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  consent: { type: Object, required: true },
  isSelected: { type: Boolean, default: false },
  isRead: { type: Boolean, default: false },
});

const emit = defineEmits(["select"]);

const { locale } = useI18n();

const isAnswered = computed(() => props.consent.answered === true);

const getLocalizedContent = (content) => {
  if (!content) return "";
  if (typeof content === "string") return content;
  if (typeof content === "object") {
    const currentLocale = locale.value || "en-GB";
    if (content[currentLocale]) return content[currentLocale];
    const langCode = currentLocale.split("-")[0];
    const langKey = Object.keys(content).find((k) => k.startsWith(langCode));
    if (langKey) return content[langKey];
    return Object.values(content)[0] || "";
  }
  return "";
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.consent-item {
  border: 1px solid $borderLightGray;
  transition: border-color 0.15s;

  &:hover {
    border-color: $darkGray;
  }

  &--selected {
    border-color: $dangerRed;
    border-left: 3px solid $dangerRed;
  }
}
</style>
